import { styled } from '@gcc/autobahn-components';

export const MessageContainerDiv = styled.div`
  margin: 0.5rem 0.5rem 0 0.5rem;
`;
